export default __webpack_public_path__ + "static/media/Room3.51dabc6e.png";